import React from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import IconSearch from '@tecuity/sos-icons/react/search'

const MiscSearchGrid = ({
  template,
  rows,
  loading,
  page,
  pageSize,
  rowCount,
  rowsPerPageOptions,
  onPageChange,
  onPageSizeChange,
  onSortModelChange,
  onRowClick,
  onViewRecord,
}) => {
  if (!template || template.length === 0) {
    return null
  }

  const columns = template.map((col) => ({
    field: col.FieldName,
    headerName: col.Header,
    sortable: col.IsSortable,
    disableColumnMenu: true,
    minWidth: 150,
    flex: 1,
  }))

  if (onViewRecord) {
    columns.unshift({
      field: 'actions',
      headerName: 'View',
      width: 70,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        if (params) {
          return (
            <div style={{ margin: 'auto' }}>
              <span title="View Record">
                <IconButton
                  onClick={() => onViewRecord(params.row)}
                  icon={<IconSearch />}
                  label="View Record"
                />
              </span>
            </div>
          )
        }
      },
    })
  }

  const rowsWithId = rows.map((r, i) => ({ ...r, id: i }))

  return (
    <GraniteDataGrid
      columns={columns}
      rows={rowsWithId}
      getRowId={(r) => r.id}
      pagination
      paginationMode="server"
      sortingMode="server"
      page={page}
      pageSize={pageSize}
      rowCount={rowCount}
      rowsPerPageOptions={rowsPerPageOptions}
      loading={loading}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSortModelChange={onSortModelChange}
      onRowClick={(params) => onRowClick(params.row)}
      autoHeight
    />
  )
}

export default MiscSearchGrid
